export const CrossIcon = (props) => (
  <svg fill="none" height={25} viewBox="0 0 24 25" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_940_2346)">
      <rect fill="#F8F8F8" height={24} rx={12} width={24} y={0.886719} />
      <path
        d="M18 6.88672L12 12.8867M12 12.8867L6 18.8867M12 12.8867L18 18.8867M12 12.8867L6 6.88672"
        stroke="#141B34"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="clip0_940_2346">
        <rect fill="white" height={24} rx={12} width={24} y={0.886719} />
      </clipPath>
    </defs>
  </svg>
);
